import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * Best Western Scandinavia
 */
const factory = function factory({ document, thn }) {
    let refreshPrice = null;
    const updatePageOnDataLayerEvent = (data) => {
        if (!data.message)
            return;
        const message = data.message;
        if (message.event === 'pageview') {
            thn.pageCheck();
        }
    };
    let onCheckoutSuccessEvent = null;
    const refreshPage = thn.debounce(() => { thn.pageCheck({ force: true }); }, 600);
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('[data-testid="hotel-rooms"] > li'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('[data-testid="hotel-rooms"] h3')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('[data-testid="hotel-rooms"] div > div li > button'))
                ?.map((rate) => {
                const rateName = rate.querySelector('[data-testid="hotel-rooms"] div > div li > button > div > div p')?.textContent;
                const ratePrice = thn.parseNumber(rate.querySelector('[data-testid="hotel-rooms"] li div button > div > div:nth-child(2) > p')?.textContent);
                const hasBreakfast = true;
                const isRefundable = !!rateName?.match(/Fri avbokning/i);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults,
                children: numChildren,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    function getDates() {
        const datesElFromDom = document.querySelectorAll('table tr td.bg-black');
        const dateBeginFromIdElm = datesElFromDom?.[0]?.id && thn.dateToString(datesElFromDom?.[0]?.id);
        const dateEndFromIdElm = datesElFromDom?.[1]?.id && thn.dateToString(datesElFromDom?.[1]?.id);
        const dateBegin = dateBeginFromIdElm || thn.parseUrlParameter('startDate')?.replace(/-/g, '/') || document.querySelector('.easepick-calendar-mount')?.textContent?.split(' - ')[0]?.replace(/-/g, '/') || '';
        const dateEnd = dateEndFromIdElm || thn.parseUrlParameter('endDate')?.replace(/-/g, '/') || document.querySelector('.easepick-calendar-mount')?.textContent?.split(' - ')[1]?.replace(/-/g, '/') || '';
        const nights = dateBegin && dateEnd ? thn.daysBetween(dateBegin, dateEnd) : 0;
        return { dateBegin, dateEnd, nights };
    }
    function getSingleRoomOcupancy() {
        const singleRoomAdults = thn.parseNumber(thn.parseUrlParameter('room[0]')?.split('_')[0] || thn.parseUrlParameter('numAdults[0]')) || 1;
        const singleRoomChildrenAgesRaw = thn.parseUrlParameter('room[0]')?.split('_')?.slice(1);
        const singleRoomChildren = singleRoomChildrenAgesRaw?.length || thn.parseNumber(thn.parseUrlParameter('numChild[0]')) || 0;
        const singleRoomChildrenAges = singleRoomChildrenAgesRaw ? singleRoomChildrenAgesRaw.map((age) => thn.parseNumber(age) || 10) : [];
        return [{
                adults: singleRoomAdults,
                children: singleRoomChildren,
                childrenAges: singleRoomChildrenAges,
            }];
    }
    function getMultipleRoomOcupancy(indexRoom) {
        const expandedRoomNumber = indexRoom;
        const roomInfo = thn.parseUrlParameter(`room[${expandedRoomNumber}]`);
        if (!roomInfo) {
            return null;
        }
        const [rawAdults, ...rawChildrenAges] = roomInfo.split('_');
        const adults = thn.parseNumber(rawAdults || thn.parseUrlParameter(`numAdults[${expandedRoomNumber}]`)) || 1;
        let childrenAges = rawChildrenAges.map((age) => thn.parseNumber(age))
            .filter((value) => value !== undefined);
        if (thn.empty(childrenAges)) {
            const children = Number(thn.parseNumber(thn.parseUrlParameter(`numChild[${expandedRoomNumber}]`))) || 0;
            childrenAges = Array(children).fill(10);
        }
        return [{ adults, children: childrenAges.length, childrenAges }];
    }
    function getRoomOcupancy(rooms, index) {
        if (thn.empty(rooms)) {
            return getSingleRoomOcupancy();
        }
        return getMultipleRoomOcupancy(index);
    }
    function getPriceAndCurrency(index) {
        const isPackagesActive = !!document.querySelector('[for*=_packages] div:not(.hidden) img[class*=white]');
        if (isPackagesActive) {
            return { prices: [], currency: 'SEK' }; // Packages are not available on OTAs
        }
        const pricesElSingleRoom = document.querySelectorAll('button > div > div > div > p') || document.querySelectorAll('[data-testid="hotel-rooms"] li div button > div > div:nth-child(3) > div > p');
        const pricesElMultiRoom = document.querySelectorAll('.list-none');
        let pricesEl;
        const targetRoom = pricesElMultiRoom[index];
        if (targetRoom) {
            pricesEl = targetRoom.querySelectorAll('li[id*=room] > div:last-child button > div > div > div > p') || targetRoom.querySelectorAll(':scope > div:not([hidden]) [data-testid="hotel-rooms"] li div button > div > div:nth-child(3) > div > p');
        }
        pricesEl = pricesEl || pricesElSingleRoom; // Fall back to normal price
        const prices = Array.from(pricesEl)
            .map((price) => thn.parseNumber(price?.textContent))
            .filter((value) => typeof value !== 'undefined' && value !== null);
        const currency = thn.parseCurrency(document.querySelector('.hidden > div.justify-end > div.flex.flex-col')?.textContent) || 'SEK';
        return { prices, currency };
    }
    return {
        onStateChange() {
            refreshPage();
        },
        boot() {
            const container = document.querySelector('#hotel-menu');
            if (container) {
                thn.observeDom(container, refreshPage, {
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
            thn.bus.on('dataLayer:push', updatePageOnDataLayerEvent, true);
            thn.shutdown(() => {
                thn.bus.detach('dataLayer:push', updatePageOnDataLayerEvent);
            });
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('[data-accordion]');
            if (container) {
                refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh().catch(() => { });
                }, 800);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true,
                    attributeFilter: ['class', 'style', 'aria-expanded'],
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        isUserLogged() {
            const isLogged = !!document.querySelector('.sticky div > button[aria-label*=Inloggad]');
            return isLogged;
        },
        generateSearchUrl(ctx) {
            // https://www.bestwestern.se/hotel/96101?type=HOTEL&startDate=2024-11-13&endDate=2024-11-14&room%5B0%5D=1_4_1
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.includes('bestwestern');
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            url.searchParams.set('type', 'HOTEL');
            url.searchParams.set('startDate', '[date_begin]');
            url.searchParams.set('endDate', '[date_end]');
            const childrenAges = ctx.data?.roomsDispo?.[0]?.childrenAges ?? [];
            if (childrenAges.length) {
                const guestsString = `${String(ctx.data?.roomsDispo?.[0]?.adults)}_${childrenAges.join('_')}`;
                url.searchParams.set('room[0]', guestsString);
            }
            else {
                url.searchParams.set('room[0]', '[adults]');
            }
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            const rooms = document.querySelectorAll('.list-none');
            const index = Array.from(rooms).findIndex(el => el.querySelector('button[aria-expanded="true"]'));
            const { dateBegin, dateEnd, nights } = getDates();
            if (!dateBegin || !dateEnd || (rooms.length && index === -1)) {
                return null;
            }
            const roomsDispo = getRoomOcupancy(rooms, index);
            if (!roomsDispo) {
                return null;
            }
            const { prices, currency } = getPriceAndCurrency(index);
            if (!thn.empty(prices) && nights) {
                return {
                    currency,
                    dateBegin,
                    dateEnd,
                    price: Math.min(...prices) / nights,
                    roomsDispo,
                    roomDetails: roomDetailsParseData(roomsDispo[0].adults, roomsDispo[0].children),
                };
            }
            const noAvailability = document.querySelector('.bg-error');
            if (noAvailability) {
                return {
                    roomsDispo,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingObserveDom(ctx) {
            if (ctx.widget.isSet() || onCheckoutSuccessEvent) {
                return;
            }
            onCheckoutSuccessEvent = (data) => {
                if (!data.message)
                    return;
                const message = data.message;
                if (message?.event === 'purchase' && ctx.widget.setData().isSet()) {
                    ctx.widget.save();
                    if (onCheckoutSuccessEvent) {
                        thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
                        onCheckoutSuccessEvent = null;
                    }
                }
            };
            thn.bus.on('dataLayer:push', onCheckoutSuccessEvent, true);
            thn.pageUnload(() => {
                if (onCheckoutSuccessEvent) {
                    thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
                    onCheckoutSuccessEvent = null;
                }
            });
        },
        bookingParseData() {
            const { dataLayer } = window;
            const bookingItems = thn.objectGet(dataLayer, 'items', { first: false }) || [];
            const dataBookings = bookingItems.map((room) => {
                // Booking ID
                const bookingId = room.booking_id;
                if (!bookingId) {
                    return {
                        set: false,
                    };
                }
                // Dates
                const dateBegin = thn.objectGet(dataLayer, 'date_check_in', { first: false })?.replace(/-/g, '/');
                const dateEnd = thn.objectGet(dataLayer, 'date_check_out', { first: false })?.replace(/-/g, '/');
                // Price & Currency
                const { price } = room;
                const currency = thn.parseCurrency(thn.objectGet(dataLayer, 'currency', { first: false }));
                return {
                    bookingId,
                    dateBegin,
                    dateEnd,
                    price,
                    currency,
                };
            });
            return dataBookings;
        },
    };
};

export { factory };
